import Sentry from '@/services/sentry'

/**
 * AHA-46283 — resolve the survey-slide session boundary (`resetTimeStamp`) from a
 * `clear-data-audience` response.
 *
 * This centralises the response-shape assumption that was previously copy-pasted
 * into the three Reset Results call sites (ResetResultsButton, Results,
 * SettingsResetResultsTab). Any change to where general-api returns the timestamp
 * now lives in exactly one place.
 *
 * The server field is added by general-api PR #2148; until it deploys the response
 * omits it and callers keep their prior value (a no-op == today's behaviour, so
 * this is safe to ship ahead of it).
 *
 * When the POST succeeds but no `resetTimeStamp` comes back we emit a Sentry
 * warning, so a silently-stale survey session count is loud rather than invisible
 * (e.g. if the field ever moves to `body.resetTimeStamp` or under `body.data`).
 *
 * @param {object} res vue-resource HttpResponse from the clear-data-audience POST
 * @returns {number|string|null} the raw `resetTimeStamp` (ms epoch), or null when absent
 */
export function resolveResetTimeStamp(res) {
  const resetTimeStamp = res?.body?.presentation?.resetTimeStamp
  if (!resetTimeStamp) {
    Sentry.captureMessage(
      'AHA-46283: clear-data-audience returned no resetTimeStamp; survey slide session count may be stale',
      { level: 'warning' },
    )
    return null
  }
  return resetTimeStamp
}
